import api from "api";

export const listItemsService = async (url: string, params?: string) => {
  const response = await api.get(url + `?${params}`, {
    headers: {
      Authorization: "Basic R0VPOkdFT0AjMzA=",
    },
  });

  return response;
};
